/* eslint-disable max-len */
import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import { type EventApplicationEntrypointContextDataFragment } from '../../../api/fragments/EventApplicationEntrypointContextData';
import {
    DraftEventApplicationDocument,
    type DraftEventApplicationMutation,
    type DraftEventApplicationMutationVariables,
} from '../../../api/mutations/draftEventApplication';
import { type CustomerKind } from '../../../api/types';
import { useLanguage } from '../../../components/contexts/LanguageContextManager';
import { type ApplicantFormValues } from './ApplicantForm/shared';

const useSubmitDraft = (eventId: string, endpoint: EventApplicationEntrypointContextDataFragment) => {
    const apolloClient = useApolloClient();
    const { currentLanguageId } = useLanguage();

    return useCallback(
        async (values: ApplicantFormValues, customerKind: CustomerKind) => {
            const { data } = await apolloClient.mutate<
                DraftEventApplicationMutation,
                DraftEventApplicationMutationVariables
            >({
                mutation: DraftEventApplicationDocument,
                variables: {
                    applicationModuleId: endpoint.eventApplicationModule.id,
                    vehicle: {
                        existingSimpleLocalVehicleId: values.vehicleInterest.variant,
                    },
                    customer: { newLocalCustomer: { fields: [] } },
                    eventId,
                    configuration: values.configuration,
                    tradeInVehicle: values.tradeInVehicle,
                    endpointId: endpoint.id,
                    dealerId: values.dealerId,
                    languageId: currentLanguageId,
                    customerKind,
                    customizedFields: values.customizedFields,
                    remarks: values.remarks,
                },
            });

            return data.result;
        },
        [apolloClient, currentLanguageId, endpoint.eventApplicationModule.id, endpoint.id, eventId]
    );
};

export default useSubmitDraft;
